import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import Mapping from '@/types/Mapping'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'

export default class MappingService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Mapping>>> {
    return await http.get<PaginatedResponse<Mapping>>(`/api/v1/office/mapping-locations?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<Mapping>>(`/api/v1/office/mapping-locations/${id}`)
  }

  async store(data: FormData) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return await http.post<DataResponse<Mapping>>(`/api/v1/office/mapping-locations`, data, { headers })
  }

  async update(id: string, data: FormData) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return await http.post<DataResponse<Mapping>>(`/api/v1/office/mapping-locations/${id}`, data, { headers })
  }

  /**
   * Responds with the CSV import report, also when the file has errors (422). The response type is left as JSON so
   * that whole-file validation errors still reach the snackbar interceptor parsed; axios falls back to the raw text
   * for the CSV.
   */
  async importSeats(id: string, file: File, dryRun: boolean): Promise<AxiosResponse<string>> {
    const form = new FormData()

    form.append('file', file)
    form.append('dry_run', dryRun ? '1' : '0')

    return await http.post<string>(`/api/v1/office/mapping-locations/${id}/seats/import`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/mapping-locations/${id}`)
  }
}
